import axios from 'axios'
import { AuthModel } from '../models/AuthModel'
import { UserModel } from '../models/UserModel'

const REACT_APP_API_URL = process.env.REACT_APP_REACT_APP_API_URL || 'api'

export const GET_USER_BY_ACCESSTOKEN_URL = `${REACT_APP_API_URL}/auth/get-user`
export const LOGIN_URL = `${REACT_APP_API_URL}/auth/login`
export const REGISTER_URL = `${REACT_APP_API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${REACT_APP_API_URL}/esqueci-minha-senha`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post(LOGIN_URL, { email, password })
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axios.post<AuthModel>(REGISTER_URL, {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, { email })
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}
